import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import Swal from 'sweetalert2';
import RestaurantsCarousel from './RestaurantsCarousel/RestaurantsCarousel';

import './ModalParthners.css'

function ModalParthners({ parthners, selectRestaurant, setResetData, calculateInvoiceTotals, shoppingCart, shoppingCartCombos, setShoppingCart, setShoppingCartCombos, showDirectParthner, buttonEnabled }) {
    const [show, setShow] = useState(false);

    const selectAction = (parthner) => {
        selectRestaurant(parthner)
        setShow(false)
        setResetData(1)
        dataStorageSet()
    }

    //save shoppingcart in localstorage
    const dataStorageSave = (parthner) => {


        if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
            let shopingcartBackup = localStorage.getItem('shopingcartBackup')
            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            if (shopingcartBackup !== null && shopingcartBackup != undefined && shopingcartBackup != '') {
                let arrayShopingCart = JSON.parse(shopingcartBackup)

                let statusFind = false
                arrayShopingCart.find((data) => {
                    if (data.branchoffice_id == branchoffice.id) {
                        data.shoppingCart = shoppingCart
                        data.shoppingCartCombos = shoppingCartCombos
                        statusFind = true
                    }
                })

                if (statusFind == false) {
                    arrayShopingCart.push({ branchoffice_id: branchoffice.id, shoppingCart: shoppingCart, shoppingCartCombos: shoppingCartCombos })
                }

                localStorage.setItem('shopingcartBackup', JSON.stringify(arrayShopingCart))
            } else {
                let dataShopingCart = { branchoffice_id: branchoffice.id, shoppingCart: shoppingCart, shoppingCartCombos: shoppingCartCombos }
                let arrayshopingcart = [dataShopingCart]
                localStorage.setItem('shopingcartBackup', JSON.stringify(arrayshopingcart))
            }

            selectAction(parthner)
        } else {
            selectAction(parthner)
        }
    }

    //Save data shoppingcart parthners
    //Function to add format products to the shopping cart
    const addProductdataSet = (selectProduct, segmentsOption, segmentsSelect) => {
        //------------------------------------------------------------

        //For default we set that the amount of the selected product depending the number 
        selectProduct.isNewAdd = true;
        selectProduct.amount = selectProduct.amount;
        selectProduct.cantidadItem = selectProduct.cantidadItem;
        selectProduct.delivery_type = "comer aqui";
        selectProduct.note = selectProduct.notes;
        selectProduct.unit_discount = 0;
        selectProduct.product_discount = 0;
        selectProduct.descuento = selectProduct.product_discount;
        selectProduct.discount = selectProduct.product_discount;
        selectProduct.kitchen_action = "send_to_kitchen"; // <-- NEW

        //For default we initialice the segments empty of the selected product
        selectProduct.segments = [];
        selectProduct.DetalleSegmentos = [];
        selectProduct.segments_string = "" + selectProduct.group_id
        //We set the segment items selected on the product selected

        let temporal_segment_string = ""
        segmentsOption.forEach((segment) => {
            let defaultCheckedSegment = segment.segment_item_id_default
            let items = segment.items

            let findSegment = segmentsSelect.find(segmentNow => segmentNow?.segment_id == segment?.segment_id)
            if (findSegment !== undefined) {
                items.forEach((item) => {
                    if (findSegment?.item_id == item?.item_id) {
                        temporal_segment_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
                        selectProduct.segments_string = selectProduct.segments_string + "" + segment.segment_id + "" + item.item_id
                        selectProduct.segments.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
                        selectProduct.DetalleSegmentos.push({ ...item, segment_name: segment.name, cantidadItem: 1, item: { name: item.name, description: item.description, img: item.img, price: item.price, item_id: item.item_id, amount: 1, taxtValue: item.taxtValue, tax: item.tax, external_reference: item.external_reference } })
                        selectProduct.price = selectProduct.price + item.price
                    }
                })
            }
        });

        return (selectProduct)
    }


    const dataStorageSet = () => {//save data shopingcart parthners

        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let shopingcartBackup = localStorage.getItem('shopingcartBackup')
        let generalData = JSON.parse(localStorage.getItem('generalData'))

        let generalDataBranchGroups = generalData.find((dataNow) => {
            if (dataNow.branchoffice_id == branchoffice.id) {
                return dataNow
            }
        })


        if (shopingcartBackup !== null && shopingcartBackup != undefined && shopingcartBackup != '') {
            let arrayShopingCart = JSON.parse(shopingcartBackup)
            arrayShopingCart.find((data) => {
                if (data.branchoffice_id == branchoffice.id) {
                    const swalWithBootstrapButtons = Swal.mixin({
                        customClass: {
                            confirmButton: "btn btn-success",
                            cancelButton: "btn btn-danger"
                        },
                        buttonsStyling: false
                    });
                    swalWithBootstrapButtons.fire({
                        title: "Hay productos en el carrito",
                        text: "Desea recuperarlos",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Si, recuperar",
                        cancelButtonText: "No, eliminar",
                        reverseButtons: true
                    }).then((result) => {
                        if (result.isConfirmed) {
                            swalWithBootstrapButtons.fire({
                                title: "Productos recuperados",
                                text: "",
                                icon: "success"
                            });


                            setShoppingCart(data.shoppingCart)
                            setShoppingCartCombos(data.shoppingCartCombos)
                            calculateInvoiceTotals(data.shoppingCart, data.shoppingCartCombos)

                            data.shoppingCart = []
                            data.shoppingCartCombos = []
                        } else if (
                            /* Read more about handling dismissals below */
                            result.dismiss === Swal.DismissReason.cancel
                        ) {
                            swalWithBootstrapButtons.fire({
                                title: "Productos eliminados",
                                text: "",
                                icon: "warning"
                            });
                            data.shoppingCart = []
                            data.shoppingCartCombos = []
                        }
                    });
                } else {
                    let foundGroupsWithCartIndex = []
                    let groupEnabled = generalDataBranchGroups?.data?.groups.filter(group => group.status === 1);

                    groupEnabled.forEach(group => {
                        let dataGroupNow = data.shoppingCart.find(item => group.group_id === item.group_id)
                        if (dataGroupNow !== undefined) {
                            dataGroupNow.segmentsOption = group.segments
                            dataGroupNow.price = group.price
                            foundGroupsWithCartIndex.push(addProductdataSet(dataGroupNow, group.segments, dataGroupNow.segments))
                        }
                    });

                    if (foundGroupsWithCartIndex.length > 0) {
                        const swalWithBootstrapButtons = Swal.mixin({
                            customClass: {
                                confirmButton: "btn btn-success",
                                cancelButton: "btn btn-danger"
                            },
                            buttonsStyling: false
                        });
                        swalWithBootstrapButtons.fire({
                            title: "Hay productos en el carrito de otra sucursal",
                            text: "Desea recuperarlos",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Si, recuperar",
                            cancelButtonText: "No, eliminar",
                            reverseButtons: true
                        }).then((result) => {
                            if (result.isConfirmed) {
                                swalWithBootstrapButtons.fire({
                                    title: "Productos recuperados",
                                    text: "",
                                    icon: "success"
                                });


                                console.log("foundGroupsWithCartIndex", foundGroupsWithCartIndex);
                                setShoppingCart(foundGroupsWithCartIndex)
                                setShoppingCartCombos([])
                                calculateInvoiceTotals(foundGroupsWithCartIndex, [])

                                data.shoppingCart = []
                                data.shoppingCartCombos = []
                            } else if (
                                /* Read more about handling dismissals below */
                                result.dismiss === Swal.DismissReason.cancel
                            ) {
                                swalWithBootstrapButtons.fire({
                                    title: "Productos eliminados",
                                    text: "",
                                    icon: "warning"
                                });
                                data.shoppingCart = []
                                data.shoppingCartCombos = []
                            }
                        });
                    }
                }
            })
            let Datafilter = arrayShopingCart.filter((data) => data.branchoffice_id != branchoffice.id)
            localStorage.setItem('shopingcartBackup', JSON.stringify(Datafilter))
        }
    }




    useEffect(() => {
        if (showDirectParthner) {
            setShow(true)
        }
    }, [showDirectParthner])




    return (
        <>
            {buttonEnabled !== false && (

                <button className="spn-item" type="button" onClick={() => setShow(true)}>
                    <span className="spn-item__ic">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M3 2v7a3 3 0 003 3v10M5 2v6M7 2v6M14 2c-1.5 1.5-2 4-2 7s.5 4 2 4v9" />
                        </svg>
                    </span>
                    <span className="spn-item__label">Restaurantes</span>
                </button >
            )}

            <Modal
                show={show}
                size="lg"
                centered
                onHide={() => setShow(false)}
                dialogClassName="sp-rest-dialog"
                contentClassName="sp-rest-content"
            >
                <Modal.Body className="sp-rest">

                    {/* Encabezado */}
                    <div className="sp-rest__head">
                                   
                            <h1 className="sp-rest__title">Restaurantes</h1>
                       
                        <button
                            className="sp-rest__x"
                            type="button"
                            aria-label="Cerrar"
                            onClick={() => setShow(false)}
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>

                    {/* Carrusel horizontal */}
                    <RestaurantsCarousel deps={parthners.length}>
                        {parthners.map((parthner, index) => (
                            <div className="sp-rest-card" key={index} onClick={() => (dataStorageSave(parthner))}>
                                <div className="sp-rest-card__imgwrap">
                                    <img src={parthner.logo} className="sp-rest-card__img" alt="Product" loading="lazy" />
                                </div>
                                <div className="sp-rest-card__body">
                                    <h5 className="sp-rest-card__title">{parthner.parthner_name}</h5>
                                </div>
                            </div>
                        ))}
                    </RestaurantsCarousel>

                    <small className="sp-rest__hint">
                        <i className="uil uil-info-circle"></i>
                        Por favor, seleccione un restaurante para continuar
                    </small>

                    {/* Footer */}
                    <div className="sp-rest__foot">
                        <button className="sp-rest__back" onClick={() => setShow(false)}>
                            <i className="uil uil-arrow-left"></i> Volver
                        </button>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalParthners